import React from "react";
import "./Media.css";

const mediaItems = [
  {
    type: "BBC News",
    title: "Bethany Branson: Family pays tribute after fatal crash",
    description:
      "BBC News coverage telling Beth's story and the impact of the crash on her family and community.",
    href: "https://www.bbc.co.uk/news/uk-england-somerset-64449886",
    action: "Read on BBC News",
  },
  {
    type: "St Giles Animal Welfare",
    title: "Beth Branson Tribute Page",
    description:
      "A tribute to Beth from St Giles Animal Welfare, a charity that was close to her heart.",
    href: "https://stgilesanimalwelfare.co.uk/about-st-giles-animal-welfare/beth-branson-tribute-page/",
    action: "View Tribute",
  },
  {
    type: "Bridgwater Mercury",
    title: "Beth Branson killer's sentence raised by Bridgwater MP",
    description:
      "Local coverage following the campaign and response to Beth's case.",
    href: "https://www.bridgwatermercury.co.uk/news/24936391.beth-branson-killers-sentence-raised-bridgwater-mp/",
    action: "Read Article",
  },
  {
    type: "BBC Sounds",
    title: "BBC Sounds: Beth Branson coverage",
    description:
      "Listen to the BBC Sounds programme featuring coverage connected to Beth's story.",
    href: "https://www.bbc.co.uk/sounds/play/p0p9q07k",
    action: "Listen on BBC Sounds",
  },
  {
    type: "Bridgwater & Albion RFC",
    title: "Rest in Peace – Taken Far Too Soon, Beth Branson",
    description:
      "A tribute from Beth's rugby club community.",
    href: "https://barfc.co.uk/rest-in-peace-taken-far-too-soon-beth-branson/",
    action: "Read Tribute",
  },
  {
    type: "LBC",
    title: "Killer drivers: Bethany Branson and Luke Hawkes",
    description:
      "LBC coverage discussing the case and the wider issue of dangerous driving.",
    href: "https://www.lbc.co.uk/article/killer-drivers-bethany-branson-luke-hawkes-DWzQnS_2/",
    action: "Read on LBC",
  },
  {
    type: "Yahoo News",
    title: "Rugby legend joins charity match",
    description:
      "Coverage of the memorial match and the support surrounding the event.",
    href: "https://uk.news.yahoo.com/rugby-legend-joins-charity-match-060000644.html",
    action: "Read Article",
  },
  {
    type: "Ashley Fox MP",
    title: "Road Safety Week: Beth's parents meet Ashley Fox MP",
    description:
      "Coverage of Beth's parents meeting Ashley Fox MP during Road Safety Week.",
    href: "https://www.ashleyfox.org.uk/news/road-safety-week-beth-bransons-parents-meet-ashley-fox-mp",
    action: "Read Article",
  },
  {
    type: "Manchester Evening News",
    title: "Driver said 'I hope I killed...' following fatal crash",
    description:
      "National coverage of the circumstances surrounding Beth's case.",
    href: "https://www.manchestereveningnews.co.uk/news/uk-news/driver-said-i-hope-killed-26114489.amp",
    action: "Read Article",
  },
  {
    type: "The Sun",
    title: "Tributes to female rugby player after horror crash",
    description:
      "Coverage and tributes following Beth's death.",
    href: "https://www.thesun.co.uk/sport/20384174/tributes-female-rugby-player-died-horror-crash/",
    action: "Read Article",
  },
];

export default function Media() {
  return (
    <section className="media-page">
      <div className="media-hero">
        <span className="media-kicker">Beth Branson Memorial Match</span>
        <h1>Media & Press</h1>
        <p>
          Read, watch and listen to coverage and tributes to Beth, as well as
          stories about the memorial match and the causes it supports.
        </p>
      </div>

      <div className="media-grid">
        {mediaItems.map((item) => (
          <article className="media-card" key={item.href}>
            <div className="media-card-top">
              <span className="media-type">{item.type}</span>
              <span className="media-arrow" aria-hidden="true">↗</span>
            </div>

            <h2>{item.title}</h2>
            <p>{item.description}</p>

            <a
              className="media-link"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.action}
              <span aria-hidden="true"> →</span>
            </a>
          </article>
        ))}
      </div>

      <div className="media-facebook">
        <div>
          <span className="media-kicker">Stay connected</span>
          <h2>Join our Facebook Community</h2>
          <p>
            Follow the group for event updates, photos, announcements and
            everything happening around the memorial match.
          </p>
        </div>

        <a
          className="media-facebook-button"
          href="https://www.facebook.com/groups/bethbranson"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="facebook-mark" aria-hidden="true">f</span>
          Visit Facebook Group
        </a>
      </div>
    </section>
  );
}
